import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

import Icon, { icons } from '../generic/Icon';
import { RouterLink } from '../generic/Link';

const AlertLimitedScanDepth = () => {
  const [isShowingModal, onShowModal] = useState<boolean>(false);
  return (
    <>
      <Button
        className="btn btn-increase-detail btn-link"
        onClick={() => onShowModal(true)}
      >
        <Icon icon={icons.warning} /> Scan depth is limited
      </Button>
      <Modal show={isShowingModal} backdrop onHide={() => onShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Scan depth for this project is limited</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Upgrade to the business plan to unlock additional features.</p>
          <RouterLink
            to="/account/settings/billing"
            className="btn btn-primary margin-bottom-sm"
          >
            Subscription Settings
          </RouterLink>
        </Modal.Body>
      </Modal>
    </>);
};

export default AlertLimitedScanDepth;
